import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';
import {
  IUserExperience,
  NumberFormatter,
  Week
} from '@summit/models';

import { EboEmployeeEvent } from '../base-classes/ebo-employee-event';
import { Employee } from '../employee/employee';
import { TruckAlias } from '../truck/truck-alias';
import { SpotRun } from './spot-run';

export class SpotAsk extends EboEmployeeEvent {
  truckNum: string;
  truckAliasID: string;
  truckAlias: TruckAlias;
  spotRunID: string;
  spotRun: SpotRun;
  odometerBegin: number;
  odometerEnd: number;
  miles: number;
  run: number;
  liveLoad: boolean;
  comment: string;
  createDate: Dayjs;
  creatorID: string;
  creator: Employee;
  baseline_EventDate: Dayjs;
  baseline_EmployeeID: string;
  baseline_Employee: Employee;
  baseline_TruckNum: string;
  baseline_TruckAliasID: string;
  baseline_TruckAlias: TruckAlias;
  baseline_spotRunID: string;
  baseline_spotRun: SpotRun;

  constructor(jsonData?: Partial<SpotAsk>) {
    super(jsonData);
    if (jsonData?.truckAlias) {
      this.truckAlias = new TruckAlias(jsonData.truckAlias);
    }
    if (jsonData?.spotRun) {
      this.spotRun = new SpotRun(jsonData.spotRun);
    }
    if (jsonData?.baseline_EventDate) {
      this.baseline_EventDate = SDate.newUtc(jsonData.baseline_EventDate);
    }
    if (jsonData?.baseline_Employee) {
      this.baseline_Employee = new Employee(jsonData.baseline_Employee);
    }
    if (jsonData?.baseline_TruckAlias) {
      this.baseline_TruckAlias = new TruckAlias(jsonData.baseline_TruckAlias);
    }
    if (jsonData?.baseline_spotRun) {
      this.baseline_spotRun = new SpotRun(jsonData.baseline_spotRun);
    }
    if (!this.liveLoad) {
      this.liveLoad = false;
    }
    //Correct a server issue until we remove truckNum from api and turn into a getter only
    if (!this.truckNum && this.truckAlias) {
      this.truckNum = this.truckAlias.name;
    }
  }

  get defaultSort() {
    return `${this.eventDate?.format('yyyMMDD')}-${this.truckAlias?.toShortString()}-${NumberFormatter(
      this.spotRun?.spotNumber,
      2
    )}-${NumberFormatter(this.run, 2)}`;
  }

  toShortString(): string {
    return `${this.eventDate?.format('M/D/YY')}-${this.truckAlias?.toShortString()}-${NumberFormatter(
      this.spotRun?.spotNumber,
      2
    )}-Run #${NumberFormatter(this.run ?? 0, 2)}-Live:${this.liveLoad ?? false}`;
  }

  isEditable(ux: IUserExperience): boolean {
    //return !this.ReconcileID
    //&&
    return ux.isBackOffice() || new Week(this.eventDate).isEditable(ux);
  }
}
